export default window._cmsContent['solar/conservation-area']